
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reciter/[slug]/surah/[surahSlug]",
      function () {
        return require("private-next-pages/reciter/[slug]/surah/[surahSlug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/reciter/[slug]/surah/[surahSlug]"])
      });
    }
  